// extracted by mini-css-extract-plugin
export default {"contact":"ContactForm_contact__D3rCZ","wrapper":"ContactForm_wrapper__D2GZm","textArea":"ContactForm_textArea__zVD-D","location":"ContactForm_location__x0P0h"};